/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { absDependencies } from './dependenciesAbs.generated';
import { addDependencies } from './dependenciesAdd.generated';
import { conjDependencies } from './dependenciesConj.generated';
import { equalScalarDependencies } from './dependenciesEqualScalar.generated';
import { largerDependencies } from './dependenciesLarger.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { multiplyDependencies } from './dependenciesMultiply.generated';
import { powDependencies } from './dependenciesPow.generated';
import { smallerDependencies } from './dependenciesSmaller.generated';
import { sqrtDependencies } from './dependenciesSqrt.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createNorm } from '../../factoriesAny.js';
export var normDependencies = {
  absDependencies: absDependencies,
  addDependencies: addDependencies,
  conjDependencies: conjDependencies,
  equalScalarDependencies: equalScalarDependencies,
  largerDependencies: largerDependencies,
  matrixDependencies: matrixDependencies,
  multiplyDependencies: multiplyDependencies,
  powDependencies: powDependencies,
  smallerDependencies: smallerDependencies,
  sqrtDependencies: sqrtDependencies,
  typedDependencies: typedDependencies,
  createNorm: createNorm
};